import {
  Link as MuiLink,
  type LinkProps as MuiLinkProps,
  type TypographyProps,
} from '@mui/material';
import type { ReactNode } from 'react';

import { isExternalLink } from '../../link';

export interface BaseLinkProps extends MuiLinkProps {
  arialabel?: string;
  scroll?: boolean;
  children: ReactNode;
  color?: TypographyProps['color'];
}

export default function BaseLink({
  component,
  href,
  className,
  arialabel,
  scroll,
  children,
  onClick,
  ...props
}: BaseLinkProps) {
  if (!href) {
    return (
      <MuiLink
        component={component || 'button'}
        aria-label={arialabel}
        className={className}
        onClick={onClick}
        {...props}
      >
        {children}
      </MuiLink>
    );
  }

  if (isExternalLink(href)) {
    return (
      <MuiLink
        component={component || 'a'}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        className={className}
        aria-label={arialabel}
        onClick={onClick}
        {...props}
      >
        {children}
      </MuiLink>
    );
  }

  return (
    <MuiLink
      href={href}
      component={component || 'a'}
      aria-label={arialabel}
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </MuiLink>
  );
}
